<template>
  <main-container>
    <a-card>
      <a-form-model
        ref="createFormRef"
        layout="horizontal"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
        :model="createForm"
      >
        <a-form-model-item label="公司名称" prop="company_name" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.company_name"></a-input>
        </a-form-model-item>
        <a-form-model-item label="税号" prop="duty" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.duty"></a-input>
        </a-form-model-item>
        <a-form-model-item label="负责人" prop="person" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.person"></a-input>
        </a-form-model-item>
        <a-form-model-item label="地址" prop="address" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.address"></a-input>
        </a-form-model-item>
        <a-form-model-item label="城市" prop="city" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.city"></a-input>
        </a-form-model-item>
        <a-form-model-item label="邮政编码" prop="code" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.code"></a-input>
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="tel" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.tel"></a-input>
        </a-form-model-item>
        <a-form-model-item label="电子邮箱" prop="email" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model="createForm.email"></a-input>
        </a-form-model-item>
        <a-form-model-item label="公司LOGO">
          <template v-if="canBeChange">
            <div class="uploaded">
              <a-avatar shape="square" :size="164" :src="createForm.logo" />
              <a-button size="small" type="dashed" @click="canBeChange = false">重新上传</a-button>
            </div>
          </template>
          <template v-else>
            <upload
              tooltip="上传jpg/png文件，且不超过6M"
              accept=".png,.jpeg,.jpg"
              :max-length="1"
              :max-size="6 * 1024 * 1024"
              :file-list="fileList"
              @change="handleUploadChange"
            ></upload>
          </template>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 12, offset: 6 }">
          <a-button @click="submit" type="primary">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </a-card>
  </main-container>
</template>

<script>
import Company from '@/api/base';
import Upload from '@/components/common/Upload';

export default {
  name: 'SettingCompany',
  components: {
    Upload,
  },
  data() {
    return {
      createForm: {
        company_name: '',
        duty: '',
        person: '',
        address: '',
        city: '',
        code: '',
        tel: '',
        email: '',
        logo: '',
      },
      canBeChange: false,
      fileList: [],
    };
  },
  created() {
    Company.compamyInfo().then(res => {
      if (res.data != false) {
        this.createForm = res.data;
        if (res.data.logo) {
          this.canBeChange = true;
        }
      }
    });
  },
  methods: {
    handleUploadChange({ fileList, path }) {
      this.fileList = fileList;
      console.log(path);
      this.createForm.logo = path;
    },
    submit() {
      this.$refs.createFormRef.validate(valid => {
        if (valid) {
          Company.upddateCompany(this.createForm).then(res => {
            if (res.code == 0) {
              this.$message.success(res.msg);
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.uploaded {
  display: flex;
  align-items: flex-end;
}
</style>
